import React from "react";
import { FormattedHTMLMessage, injectIntl } from "react-intl";
import { FormSelectChoice, InputSelectComponentProps } from "../../../lib/types/types";
import { FieldLabel } from "../../FieldLabel";
import { InputSelectComponent } from "../../FormInputs/InputSelect/InputSelectComponent";

export const FirstResponderStatus = ({
  value,
  isErrored,
  options,
  onChange,
  placeholder = "",
  intl,
  onKeyDown = undefined,
}: InputSelectComponentProps) => {
  const inputId = "sid-first-responder-status";

  return (
    <div className={`sid-field ${inputId}`}>
      <div className="sid-l-space-top-md" />
      <FieldLabel
        text={<FormattedHTMLMessage id="status" defaultMessage="Status" />}
        htmlForLabel={`${inputId}`}
        id={`${inputId}-label`}
        displayClasses={placeholder && "sid-h-screen-reader-only"}
      />

      <InputSelectComponent
        fieldId="status"
        inputId={inputId}
        fieldLabelId={`${inputId}-label`}
        isErrored={isErrored}
        options={options}
        onChange={(status: FormSelectChoice) => onChange(status)}
        onKeyDown={onKeyDown}
        value={value}
        placeholder={
          placeholder || intl.formatMessage({ id: "statusPlaceholder", defaultMessage: "Status*" })
        }
      />
      {isErrored ? (
        <div className="sid-field-error">
          <FormattedHTMLMessage
            id="errorId.invalidStatus"
            defaultMessage="Invalid first responder status"
          />
        </div>
      ) : null}
    </div>
  );
};

export const FirstResponderStatusComponent = injectIntl(FirstResponderStatus);
